<div class="kng-status-selector">
  <div class="dropdown-selector">
    <div class="selector-header">
      {{state.header}}
    </div>
    <select class="form-select selector-select selector-font" aria-label="select dropdown" (change)="onSelectionChange(screenView.mobile,$event)" [(ngModel)]="state.selectedStatus" name="status-selector">
      <option class="selector-font selector-options" *ngFor="let item of state.count" [value]="item.header">
          <div> {{item?.label}} <span class="p-l-6">({{item?.amount}})</span> </div>
      </option>
    </select>
  </div>
  <div class="btn-group" role="group" attr.aria-label={{state.header}}>
    <button type="button" class="btn btn-outline-primary status-btn status-btn--{{item.header}}" 
    *ngFor="let item of state.count; let i=index" (click)="onSelectionChange(screenView.desktop, item.header)"
    [ngClass]="{'selected-status-btn': item.header === state.selectedStatus, 'selected-all-btn': item.header === state.selectedStatus && state.selectedStatus === 'all'}"
    ><span class="invoice-status-indicator invoice-status-indicator--{{item.header}}"></span> {{item?.label}}
    <span>({{item?.amount}})</span>
  </button>
  </div>
</div>
